import {useContext, useState} from "react";
import EventContext from '/context/EventContext.js';
import {SvgLock} from "/components/shared/SvgIcons";
import {some} from 'lodash';
import AppContext from '/context/AppContext';
import {post} from '/api_utils';
import Spinner from '/components/shared/TicketWidget/Spinner';

export default function AdditionalMaterialView({id, classIdentifier}) {
    const {event} = useContext(EventContext);
    const [code, setCode] = useState('');
    const [codeInvalid, setCodeInvalid] = useState(false);
    const [verifyingCode, setVerifyingCode] = useState(false);
    const {activeShow, setActiveShow, addToken, products: allowedProducts} = useContext(AppContext);

    let products = (event.products || []).map(product => {
        if (!product.behind_paywall) {
            return product;
        }

        if (allowedProducts[product.id]) {
            return allowedProducts[product.id];
        }

        product.locked = true;
        return product;
    });

    if (!products.length) {
        return null;
    }

    async function validateCode() {
        setVerifyingCode(true);
        let resp = await post('/api/validate-for-production', {
            code,
            slug: event.slug
        });
        if (resp.status === 200) {
            const redemption = await resp.json();
            addToken(redemption.device_token);
        } else {
            setCodeInvalid(true);
        }
        setVerifyingCode(false);
    }

    let locked = some(products, 'locked');

    return (
        <section className={classIdentifier} id={id}>
            <div className='mt-8 pb-24'>
                <div className='xl:flex flex-wrap xl:flex-nowrap mb-6'>
                    <h3 className='text-lg xl:text-xl xl:mb-1 mb-4 text-gray-dark font-cooper mr-8'>Zusatzmaterial</h3>
                    {locked ? (
                        <div className="flex items-center flex-1">
                            <SvgLock/>
                            <p className='ml-[19px] text-sm'>
                                Nur verfügbar mit einem gültigen Ticket Code
                            </p>
                        </div>
                    ) : null}
                </div>

                {locked ? (
                    <div
                        className='flex flex-wrap justify-center items-center bg-gray-light py-6 px-6'>
                        <input className="w-32 xl:w-64 h-10 xl:h-12 p-4 bg-white shadow-bx-light text-gray-dark"
                               value={code}
                               onChange={event => {
                                   setCode(event.target.value);
                                   setCodeInvalid(false);
                               }}
                               placeholder="Ticket Code"/>
                        <button
                            disabled={!code}
                            className={`${codeInvalid ? 'bg-red-500' : (!code ? 'bg-gold' : 'bg-gold')} ml-4 text-white font-bold py-2 xl:py-3 px-4 xl:px-8 text-sm rounded-full uppercase flex justify-center items-center`}
                            onClick={validateCode}>
                            {verifyingCode ? <>
                                <Spinner/>überprüfe...</> : (codeInvalid ? 'Code ungültig' : (!code ? 'Code eingeben' : 'Code prüfen'))}
                        </button>
                    </div>
                ) : (
                    <div className='flex items-center bg-gray-light py-6 px-6'>
                        Sie haben Zugriff auf das gesamte Zusatzmaterial
                    </div>
                )}

                <div className='flex flex-wrap mt-10'>
                    {products.map(product => (
                        <div key={product.id} className='mr-4 mb-4 '>
                            <div className='text-gray-dark w-44 h-8 mb-4'>
                                <p className='truncate'>{product.title} ({product.mime_type || 'PDF'}) </p>
                            </div>
                            <div
                                className='hover:scale-105 cursor-pointer transition-transform bg-blue-light w-[220px] h-[274px] flex justify-center items-center bg-no-repeat bg-center bg-cover'
                                style={{backgroundImage: `url(${product.picture})`}}
                            >
                                {product.locked ? (<div className="p-4 rounded-lg bg-white"><SvgLock/></div>) :
                                 <a target="_blank" href={product.download_url} className="p-4 rounded-lg bg-white">
                                   <div className="underline uppercase font-bold text-gold">Herunterladen</div>
                                 </a>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
